import { getImageThumbnail } from './FetchData';

// One loader per quiz run. Only requested questions start thumbnail lookups.
export const createQuestionMediaLoader = (questions, quizType) => {
    const pending = new Map();
    const preloaded = new Set();
    const imageOptions = ['listen', 'listen3', 'audioSelect'].includes(quizType);

    const preload = (url) => {
        if (!url || preloaded.has(url) || typeof Image === 'undefined') return;
        preloaded.add(url);
        const image = new Image();
        image.decoding = 'async';
        image.src = url;
        // Fetch the actual image as well as its URL, without delaying the question.
        if (image.decode) void image.decode().catch(() => {});
    };

    const resolve = async (value) => {
        if (Array.isArray(value)) return Promise.all(value.map(resolve));
        const url = await getImageThumbnail(value);
        preload(url);
        return url;
    };

    return {
        load(index) {
            if (!questions[index]) return Promise.resolve({});
            if (!pending.has(index)) {
                const question = questions[index];
                const fields = ['image1', 'image2', 'image3'];
                if (imageOptions) fields.push('options');
                const promise = Promise.all(fields.filter(key => key in question).map(async key =>
                    [key, await resolve(question[key])]
                )).then(entries => ({ ...Object.fromEntries(entries), mediaReady: true }));
                pending.set(index, promise);
            }
            return pending.get(index);
        },
    };
};
